import { Component, Input, ViewChild, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TableFilter } from '@models/tableFilter';
import { NgbDate, NgbDatepicker, NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '@services/form/form.service';

@Component({
  selector: 'app-table-filter',
  templateUrl: './table-filter.component.html',
  styleUrls: ['./table-filter.component.scss'],
})
export class TableFilterComponent implements OnInit { 
  @Input() defaultFilter: TableFilter; // default values comming from html
  @Output() setFilterEvent = new EventEmitter<TableFilter>();

  public filter: TableFilter = new TableFilter(); //used for conditions in SQL-Statement
  public filterOptions: any = {};

  public hoveredDate: NgbDate;
  public fromDate: NgbDate;
  public toDate: NgbDate;

  public mobileView: boolean = false;

  @ViewChild('filterOptionsDrop') filterOptionsDrop: NgbDropdown;
  @ViewChild('dp') datePicker: NgbDatepicker;

  constructor(public formService: FormService){}

  ngOnInit(): void {
    window.screen.width >= 574 ? this.mobileView = false : this.mobileView = true;
    this.createForm()
  }

  createForm() {
    this.formService.form = new UntypedFormGroup({
      filterForNumberOfEntries: new UntypedFormControl(),
      numberOfEntries: new UntypedFormControl(),
      filterForTimeSpan: new UntypedFormControl(),
      timeSpan: new UntypedFormControl(),
      filterSignalWeek: new UntypedFormControl(),
      filterDLM: new UntypedFormControl()
    });

    this.setDefaultValues()
    this.formService.formCreated = true
  }

  setDefaultValues() {
    var fromDate: NgbDate;
    var toDate: NgbDate;
      this.formService.form.get('filterDLM').setValue(true);
      this.formService.form.get('filterSignalWeek').setValue(true);


    if(this.defaultFilter.entries != null) 
    {
      this.formService.form.get('filterForNumberOfEntries').setValue(true)
      this.formService.form.get('numberOfEntries').setValue(this.defaultFilter.entries)
    }
    else 
    {
      this.formService.form.get('filterForNumberOfEntries').setValue(false)
      this.formService.form.get('numberOfEntries').setValue(1000)
      this.formService.form.get('numberOfEntries').disable()
    }

    if(this.defaultFilter.fromDate != null && this.defaultFilter.toDate != null)
    {
      var fromDateArray = this.defaultFilter.fromDate.split('-')
      fromDate = new NgbDate(parseInt(fromDateArray[0]), parseInt(fromDateArray[1]), parseInt(fromDateArray[2]))

      var toDateArray = this.defaultFilter.toDate.split('-')
      toDate = new NgbDate(parseInt(toDateArray[0]), parseInt(toDateArray[1]), parseInt(toDateArray[2]))

      this.formService.form.get('filterForTimeSpan').setValue(false)
      this.formService.form.get('timeSpan').setValue(this.formatTimeSpan(fromDate, toDate))
    }
    else
    {
      let today = new Date()
      let thirtyDaysAgo = new Date(today.getTime() - 2592000000)
      toDate = new NgbDate(today.getFullYear(), today.getMonth()+1, today.getDate())
      fromDate = new NgbDate(thirtyDaysAgo.getFullYear(), thirtyDaysAgo.getMonth()+1, thirtyDaysAgo.getDate())
      
      this.formService.form.get('filterForTimeSpan').setValue(true)
      this.formService.form.get('timeSpan').setValue(this.formatTimeSpan(fromDate, toDate))
    }

    this.setupFilter()
  }

  setupFilter() {
    this.filter.entries = this.formService.form.get('filterForNumberOfEntries').value ? this.formService.form.get('numberOfEntries').value : null;

    if(this.formService.form.get('filterForTimeSpan').value) {
      var dates = this.formService.form.get('timeSpan').value.split(' - ');
      
      if(this.parseDate(dates[0]) <= this.parseDate(dates[1])) {
        var dateFrom = dates[0].split('.');
        var dateTo = dates[1].split('.');
      } else {
        var dateFrom = dates[1].split('.');
        var dateTo = dates[0].split('.');  
      }

      this.filter.fromDate = dateFrom[2] +'-'+ dateFrom[1] +'-'+ dateFrom [0] +' 00:00:00.0000000'
      this.filter.toDate = dateTo[2] +'-'+ dateTo[1] +'-'+ dateTo [0] +' 23:59:59.9999999'
    } else {
      this.filter.fromDate = null;
      this.filter.toDate = null;
    }

    this.filter.showDLM = this.formService.form.get('filterDLM').value;
    this.filter.showSignal = this.formService.form.get('filterSignalWeek').value;
    this.updateTable()
  }
  
  parseDate(date) {
    date = date.split('.');
    return new Date(date[2], date[1]-1, date[0]);
  }

  updateFilter() { // enables/disables filteroptions wether their Checkboxes are checked or not
    this.formService.form.get('filterForNumberOfEntries').value ? this.formService.form.get('numberOfEntries').enable() : this.formService.form.get('numberOfEntries').disable()
    this.formService.form.get('filterForTimeSpan').value ? this.formService.form.get('timeSpan').enable() : this.formService.form.get('timeSpan').disable()
    this.formService.form.get('filterForTimeSpan').value ? document.getElementById('filterTimeSpanDropdown').removeAttribute('disabled') : document.getElementById('filterTimeSpanDropdown').setAttribute('disabled', 'true')
  }

  applyFilters() {
    this.setupFilter()
    this.filterOptionsDrop.close()
  }

  updateTable() {
    this.setFilterEvent.emit(this.filter);
  }


  // Functions for Datepicker:
  onInputChange(event) {
    this.changeFromToDate(event);
  }

  changeFromToDate(event) {
    this.filterOptions.fromDate = null;
    this.filterOptions.toDate = null;

    var fromToSplit = event.target.value.split(" - ");
    var fromParts = fromToSplit[0].split(".");
    var toParts = fromToSplit[1].split(".");

    var FromDay = Number(fromParts[0]);
    var FromMonth = Number(fromParts[1]);
    var FromYear = Number(fromParts[2]);

    this.filterOptions.fromDate = new NgbDate(FromYear, FromMonth, FromDay);

    var ToDay = Number(toParts[0]);
    var ToMonth = Number(toParts[1]);
    var ToYear = Number(toParts[2]);

    this.filterOptions.toDate = new NgbDate(ToYear, ToMonth, ToDay);

    this.formService.form.get("timeSpan").setValue(this.formatTimeSpan(this.filterOptions.fromDate, this.filterOptions.toDate));
  }

  isHovered(date: NgbDate) {
    return this.filterOptions.fromDate && !this.filterOptions.toDate && this.filterOptions.hoveredDate && (date.after(this.filterOptions.fromDate) && date.before(this.filterOptions.hoveredDate) || date.after(this.filterOptions.hoveredDate) && date.before(this.filterOptions.fromDate));
  }

  isInside(date: NgbDate) {
    return date.after(this.filterOptions.fromDate) && date.before(this.filterOptions.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.filterOptions.fromDate) || date.equals(this.filterOptions.toDate) || this.isInside(date) || this.isHovered(date);
  }

  formatTimeSpan(fromDate: NgbDate, toDate: NgbDate) {
    return (fromDate ? '' + ('00' + fromDate.day).slice(-2) + "." + ('00' + fromDate.month).slice(-2) + "." + fromDate.year : "")
      + " - " +
      (toDate ? '' + ('00' + toDate.day).slice(-2) + "." + ('00' + toDate.month).slice(-2) + "." + toDate.year : "")
  }

  onDateSelection(date: NgbDate, drop: any) {
    this.onDateSelectionOwn(date, drop);
  }

  onDateSelectionOwn(date: NgbDate, drop: NgbDropdown) {
    if (!this.filterOptions.fromDate && !this.filterOptions.toDate) {
      this.filterOptions.fromDate = date;
    } else if (this.filterOptions.fromDate && !this.filterOptions.toDate) {
      if (date.after(this.filterOptions.fromDate)) {
        this.filterOptions.toDate = date;
      }
      else if (date.before(this.filterOptions.fromDate)) {
        this.filterOptions.toDate = this.filterOptions.fromDate;
        this.filterOptions.fromDate = date;
      }
      else if (date.equals(this.filterOptions.fromDate)) {
        this.filterOptions.toDate = date;
      }
      drop.close();
    } else {
      this.filterOptions.toDate = null;
      this.filterOptions.fromDate = date;
    }

    this.formService.form.get("timeSpan").setValue(this.formatTimeSpan(this.filterOptions.fromDate, this.filterOptions.toDate));

    if (this.filterOptions.fromDate && this.filterOptions.toDate) {
    }
  }
}
